import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

/**
 * This Slice used for get all product without pagination for dropdown actions
 */

export const fetchAllProductList = createAsyncThunk(
  "fetchAllProductList",
  async () => {
    const token = localStorage.getItem("auth_token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `product/list?page=1&limit=10000000`,
      config
    );

    return response.data.data;
  }
);

const AllProductListSlice = createSlice({
  name: "AllProductListSlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchAllProductList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchAllProductList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchAllProductList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default AllProductListSlice.reducer;
